import { Component, Input, OnInit, ViewChild } from '@angular/core'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { Store } from '@ngrx/store'
import { OpenGuestOverlay } from '@tv3/store/overlay/overlay.actions'

@Component({
  selector: 'app-guest-results-table',
  templateUrl: './guest-results-table.component.html',
  styles: [
    `
      table {
        width: 100%;
      }
    `,
  ],
})
export class GuestResultsTableComponent implements OnInit {
  @Input() results: any[] = []

  @ViewChild('paginator') set paginator(p: MatPaginator) {
    this.dataSource.paginator = p
  }

  dataSource = new MatTableDataSource<any>()
  displayedColumns = ['name', 'email', 'created', 'lastmessage']

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.dataSource.data = this.results || []
  }

  onEdit(guest: any) {
    this.store.dispatch(OpenGuestOverlay({ guestId: guest.pkey }))
  }
}
